import QueryString from 'utils/query_string'
import WebsiteConfigs from 'website_configs/website_configs'

const COOKIE_CATEGORY = 'marketing'
const SESSION_GCLID_PARAMS_KEY = 'gclid_params'

class GclidFlag {
  static save () {
    if (WebsiteConfigs.displayCookiesConsent && window.orejime && window.orejime.internals.manager.consents[COOKIE_CATEGORY] !== true) {
      return
    }

    const gclidParams = QueryString.parseGclidParams(window.location.search)

    if (Object.keys(gclidParams).length) {
      sessionStorage.setItem(SESSION_GCLID_PARAMS_KEY, JSON.stringify(gclidParams))
    }
  }

  static isPresent () {
    const params = JSON.parse(sessionStorage.getItem(SESSION_GCLID_PARAMS_KEY) || '{}')
    return Object.keys(params).length > 0
  }
}

export default GclidFlag
